import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import EditeUnitsdialog from "./EditeUnitsdialog";
import CircularProgress from "@mui/material/CircularProgress";

import { getMeasurementUnitsList } from "../../../../../services/Admin/MaterialsApi";
import AddUnitsDialog from "./AddUnitsDialog";
import { useAuth } from "../../../../../Context/AuthContext";


const UnitsTab = () => {
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editUnit, setEditUnit] = useState(null);
  const { hasPermission } = useAuth();

  const fetchUnits = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await getMeasurementUnitsList();
      setUnits(res?.data || []);
    } catch (err) {
      setError(err?.message || "Failed to load units");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) fetchUnits();
    return () => (mounted = false);
  }, []);

  if (loading)
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
        <CircularProgress />
      </Box>
    );

  if (error) return <Box sx={{ color: "error.main", p: 2 }}>{String(error)}</Box>;

  return (
    <Box>
                  {hasPermission("add") && (

      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
        <Button variant="contained" onClick={() => setAddDialogOpen(true)}>إضافة وحدة قياس</Button>
      </Box>
                  )}

      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>الاسم</TableCell>
              <TableCell>الاختصار</TableCell>
              <TableCell>الحالة</TableCell>
              <TableCell align="right">إجراءات</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {units.map((u) => (
              <TableRow key={u.id} hover>
                <TableCell>{u.name}</TableCell>
                <TableCell>{u.abbreviation}</TableCell>
                <TableCell>{u.status ? "متاح" : "غير متاح"}</TableCell>
                              {hasPermission("edit") && (

                <TableCell align="right">
                  <IconButton size="small" aria-label="edit" onClick={() => { setEditUnit(u); setEditDialogOpen(true); }}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                </TableCell>
                              )}
                
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <AddUnitsDialog
        open={addDialogOpen}
        onClose={() => setAddDialogOpen(false)}
        onAdded={() => {
          fetchUnits();
        }}
      />
      <EditeUnitsdialog
        open={editDialogOpen}
        onClose={() => setEditDialogOpen(false)}
        unit={editUnit}
        onUpdated={() => {
          fetchUnits();
          setEditDialogOpen(false);
        }}
      />
    </Box>
  );
};

export default UnitsTab;
